<div *ngIf="!isResetPressed">
  <div aria-labelledby="swal2-title" aria-describedby="swal2-content" class="swal2-popup swal2-modal swal2-icon-info swal2-show" tabindex="-1" role="dialog" aria-live="assertive" aria-modal="true" style="display: flex;">
    <div class="swal2-header">
      <div class="swal2-icon swal2-info swal2-icon-show" style="display: flex;">
        <div class="swal2-icon-content">i</div>
      </div>
      <img class="swal2-image" style="display: none;">
      <h2 *ngIf="!currentStatus" class="swal2-title" id="swal2-title" style="display: block;" i18n="@@EnableFreeChargeHeader">Kostenloses Laden aktivieren?</h2>
      <h2 *ngIf="currentStatus" class="swal2-title" id="swal2-title" style="display: block;" i18n="@@DisableFreeChargeHearder">Kostenloses Laden deaktivieren?</h2>
    </div>
    <div class="swal2-content">
      <div id="swal2-content" class="swal2-html-container" style="display: block;" i18n="@@WarningChangesOfFreeChargeModusRequiresRestartOfChargingStation">Für diese Änderung wird ein Neustart erforderlich.</div>
    </div>
    <div class="swal2-actions">
      <div class="swal2-loader"></div>
      <button type="button" id="cancel" class="btn btn-yellow mb-2 mb-md-0" aria-label="" style="display: inline-block;" (click)="onCancelClick()" i18n="@@CancelButton">Abbrechen</button>
      <button type="button" id="confirm" class="ms-2 btn btn-primary mb-2 mb-md-0" aria-label="" style="display: inline-block;" (click)="onConfirmClick()" i18n="@@ResetButton">Lademodus ändern & neustarten</button>
    </div>
  </div>
</div>

<div *ngIf="isResetPressed">
  <div aria-labelledby="swal2-title" aria-describedby="swal2-content" class="swal2-popup swal2-modal swal2-icon-success swal2-show" tabindex="-1" role="dialog" aria-live="assertive" aria-modal="true" style="display: flex;">

    <div *ngIf="state == 'loading'">
      <div class="swal2-header">
        <mat-spinner [diameter]="80"></mat-spinner>
        <h2 class="swal2-title" id="swal2-title" style="display: block;" i18n="@@ConfigurationOfChargingStationIsChangedHeader">Konfiguration der Ladestation wird geändert.</h2>
      </div>
      <div class="swal2-content">
        <div id="swal2-content" class="swal2-html-container" style="display: block;" i18n="@@RestartOfChargingStationAfterConfigurationChange">Nach der Konfigurationsänderung findet ein Neustart der Ladestation statt.</div>
      </div>
    </div>

    <div *ngIf="state == 'success'">
      <div class="swal2-header">
        <div class="swal2-icon swal2-success swal2-icon-show" style="display: flex;">
          <div class="swal2-success-circular-line-left" style="background-color: rgb(255, 255, 255);"></div>
          <span class="swal2-success-line-tip"></span> <span class="swal2-success-line-long"></span>
          <div class="swal2-success-ring"></div>
          <div class="swal2-success-fix" style="background-color: rgb(255, 255, 255);"></div>
          <div class="swal2-success-circular-line-right" style="background-color: rgb(255, 255, 255);"></div>
        </div>
        <h2 class="swal2-title" id="swal2-title" style="display: block;" i18n="@@ConfigurationSuccessfullyChangedHeader">Konfiguration erfolgreich geändert.</h2>
      </div>
      <div class="swal2-content">
        <div id="swal2-content" class="swal2-html-container" style="display: block;" i18n="@@ChargingStationIsNowRestartedMessage">Die Ladestation wird nun neu gestartet.</div>
      </div>
    </div>

    <div *ngIf="state == 'failure'">
      <div class="swal2-header">
        <div class="swal2-icon swal2-error swal2-icon-show" style="display: flex;">
          <span class="swal2-x-mark">
            <span class="swal2-x-mark-line-left"></span>
            <span class="swal2-x-mark-line-right"></span>
          </span>
        </div>
        <h2 class="swal2-title" id="swal2-title" style="display: block;" i18n="@@ConfigurationChangesError">Fehler beim Ändern der Konfiguration.</h2>
      </div>
      <div class="swal2-content">
        <div id="swal2-content" class="swal2-html-container" style="display: block;" i18n="@@ErrorWhileConfiguringChargingStationMessage">Beim Konfigurieren der Ladestation ist ein Fehler aufgetreten.</div>
      </div>
    </div>

    <div class="swal2-actions">
      <div class="swal2-loader"></div>
      <button type="button" id="ok" class="swal2-confirm swal2-styled" aria-label="" style="display: inline-block;" (click)="onOkClick()" i18n="@@OkButton">OK</button>
    </div>
  </div>
</div>
